const initialState = {
    mendixUser: null
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_MENDIX_USER":
            return { ...state, mendixUser: action.payload };

        case "LOGOUT_USER":
            return { ...state, mendixUser: null };

        default:
            return state;
    }
}